import { type RowSelectionState } from "@tanstack/react-table";
import { atom } from "jotai";

export const selectedRowsAtom = atom<RowSelectionState>({});
export const selectedRowsDataAtom = atom<unknown[]>([]);
